export const GET_POLICIES_REQUEST = "GET_POLICIES_REQUEST";
export const GET_POLICIES_RESPONSE = "GET_POLICIES_RESPONSE";
export const GET_CREDIT_LINE_REQUEST = "GET_CREDIT_LINE_REQUEST";
export const GET_CREDIT_LINE_RESPONSE = "GET_CREDIT_LINE_RESPONSE";
export const SET_TOTAL_PAYMENT = "SET_TOTAL_PAYMENT";
export const CLEAR_ERROR_PAYMENTS = "CLEAR_ERROR_PAYMENTS";
export const SET_UI_LOADING = "SET_UI_LOADING";
